import {
  VisitNoteTemplate,
  VisitNoteTemplateControllerApi,
} from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

interface Params {
  visitNoteTemplate: VisitNoteTemplate;
  xTENANTID?: string;
}

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useVisitNoteTemplateCreate = () =>
  useMutationWithLoading(async (params: Params) =>
    new VisitNoteTemplateControllerApi(
      getConfigObject()
    ).createVisitNoteTemplate(params?.visitNoteTemplate, params?.xTENANTID)
  );
